<template>
  <div class="layout">
    <div class="layout__header">
      <h3>Punto de emision {{ modelValue.numero_secuencia }}</h3>
    </div>
    <div class="row">
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            id="numero_secuencia"
            v-model="modelValue.numero_secuencia"
            placeholder="###"
          >
            N° de secuencia
            <span
              v-if="errores.numero_secuencia"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_secuencia[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div :class="{'select2--disabled' : modelValue.id !== ''}" class="form-field select2">
          <div class="select2-field">
            <v-select
              label="descripcion"
              :options="tiposComprobante"
              placeholder="Seleccione..."
              id="tipoComprobante"
              v-model="selectedTipoComprobante"
            ></v-select>
            <label for="tipoComprobante">Tipo de comprobante</label>
            <span v-if="errores.id_tipo_comprobante" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.id_tipo_comprobante[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-inline">
          <label>
            <p>
              <strong>Tipo de punto de emisión</strong>
            </p>
          </label>
          <label
            v-show="this.modelValue.id_tipo_comprobante !== '00' && this.modelValue.id_tipo_comprobante !== '99'"
            for="electronico"
          >
            <input
              type="radio"
              :disabled="modelValue.id !== ''"
              id="electronico"
              v-model="modelValue.tipo"
              value="E"
            />
            <span>Electrónico</span>
          </label>
          <label for="manual">
            <input
              :disabled="modelValue.id !== ''"
              type="radio"
              id="manual"
              value="M"
              v-model="modelValue.tipo"
            />
            <span>Manual</span>
          </label>
          <span v-if="errores.tipo" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.tipo[0] }}</strong>
          </span>
        </div>
        <div
          v-show="modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
          class="form-field"
        >
          <input-field
            type="tel"
            v-mask="'##########'"
            v-model="modelValue.numero_autorizacion"
            id="numero_autorizacion"
            placeholder="##########"
          >
            Número de autorización
            <span
              v-if="errores.numero_autorizacion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_autorizacion[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div
          v-show="modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
          class="form-field"
        >
          <input-field
            type="tel"
            v-model="modelValue.numero_inicial"
            v-mask="'#########'"
            id="numero_inicial"
            placeholder="#########"
          >
            Número inicial
            <span
              v-if="errores.numero_inicial"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_inicial[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div v-show="modelValue.pre_impresion" class="form-field">
          <input-field v-model="modelValue.medida_superior" id="medida_superior" placeholder="cm">
            Medida superior
            <span
              v-if="errores.medida_superior"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.medida_superior[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div
          v-show="modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
          class="form-field"
        >
          <div class="datepicker-field">
            <date-picker
              type="date"
              format="dd-MM-yyyy"
              id="fecha_caducidad"
              v-model="modelValue.fecha_caducidad"
              lang="es"
            ></date-picker>
            <label for="fecha_caducidad">Fecha de caducidad</label>
            <span v-if="errores.fecha_caducidad" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.fecha_caducidad[0] }}</strong>
            </span>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6">
        <div class="form-field">
          <input-field
            v-model="modelValue.descripcion"
            id="descripcionPuntoEmision"
            placeholder="Nombre o descripción"
          >
            Descripción
            <span
              v-if="errores.descripcion"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.descripcion[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div class="form-field">
          <input-field
            :readonly="modelValue.id !== '' && modelValue.tipo === 'E'"
            v-model="modelValue.numero_actual"
            type="tel"
            v-mask="'#########'"
            id="numero_actual"
            placeholder="#########"
          >
            Número actual
            <span
              v-if="errores.numero_actual"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_actual[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div
          v-show="modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
          class="form-field"
        >
          <input-field
            type="tel"
            v-model="modelValue.numero_final"
            v-mask="'#########'"
            id="numero_final"
            placeholder="#########"
          >
            Número final
            <span
              v-if="errores.numero_final"
              class="helper-text text-danger"
              slot="helper"
            >
              <strong>{{ errores.numero_final[0] }}</strong>
            </span>
          </input-field>
        </div>
        <div
          v-show="modelValue.id_tipo_comprobante !== '00' && modelValue.tipo === 'M'"
          class="form-field"
        >
          <div class="datepicker-field">
            <date-picker
              type="date"
              format="dd-MM-yyyy"
              id="fecha_autorizacion"
              v-model="modelValue.fecha_autorizacion"
              lang="es"
            ></date-picker>
            <label for="fecha_autorizacion">Fecha de autorización</label>
            <span v-if="errores.fecha_autorizacion" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.fecha_autorizacion[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-field select2">
          <div class="select2-field">
            <v-select
              label="nombre"
              :options="usuarios"
              multiple
              id="usuarios"
              placeholder="Seleccione..."
              v-model="selectedUsuarios"
            ></v-select>
            <label for="usuarios">Usuarios</label>
            <span v-if="errores.usuarios" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.usuarios[0] }}</strong>
            </span>
          </div>
        </div>
        <div class="form-field">
          <label for="puntoVenta">
            <input type="checkbox" id="puntoVenta" v-model="modelValue.punto_venta" />
            <span>Impresión por punto de venta</span>
          </label>
          <label for="es_autorizable">
            <input type="checkbox" id="es_autorizable" v-model="modelValue.es_autorizable" />
            <span>Es autorizable</span>
          </label>
          <label for="grava_iva">
            <input type="checkbox" id="grava_iva" v-model="modelValue.grava_iva" />
            <span>Grava IVA</span>
          </label>
          <label v-show="modelValue.tipo === 'M' && modelValue.punto_venta">
            <input type="checkbox" id="pre_impresion" v-model="modelValue.pre_impresion" />
            <span>Formato pre-impreso</span>
          </label>
        </div>
        <div v-show="modelValue.pre_impresion" class="form-field">
          <input-field v-model="modelValue.medida_inferior" id="medida_inferior" placeholder="cm">
            <span>Medida superior</span>
            <span v-if="errores.medida_inferior" class="helper-text text-danger" slot="helper">
              <strong>{{ errores.medida_inferior[0] }}</strong>
            </span>
          </input-field>
        </div>
      </div>
    </div>
    <div class="modal-buttons">
      <button @click="cerrar" class="btn-danger btn--text" type="button">
        <i class="fa fa-close"></i>
        <span>Cerrar</span>
      </button>
      <button @click="aceptar" class="btn-success" type="button">
        <i class="fa fa-check"></i>
        <span>Aceptar</span>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: function() {
        return {
          id: "",
          numero_secuencia: "",
          descripcion: "",
          tipo: "E",
          numero_inicial: "",
          numero_actual: "",
          numero_final: "",
          numero_autorizacion: "",
          fecha_autorizacion: moment(new Date()).format("YYYY-MM-DD"),
          id_tipo_comprobante: "",
          estado: "A",
          fecha_caducidad: moment(new Date()).format("YYYY-MM-DD"),
          medida_superior: 0,
          medida_inferior: 0,
          punto_venta: false,
          pre_impresion: false,
          usuarios: []
        };
      },
      required: false
    }
  },
  updated: function() {
    let that = this;
    let numeroDocumento = (numeroDocumento = document.getElementById(
      "numero_final"
    ));
    if (numeroDocumento !== undefined && numeroDocumento !== null)
      numeroDocumento.onblur = function() {
        that.modelValue.numero_final = numeroDocumento.value.padStart(9, "0");
      };
    let numeroDocumento2 = document.getElementById("numero_inicial");
    if (numeroDocumento2 !== undefined && numeroDocumento2 !== null)
      numeroDocumento2.onblur = function() {
        that.modelValue.numero_inicial = numeroDocumento2.value.padStart(
          9,
          "0"
        );
      };
    let numeroDocumento3 = document.getElementById("numero_actual");
    if (numeroDocumento3 !== undefined && numeroDocumento2 !== null)
      numeroDocumento3.onblur = function() {
        that.modelValue.numero_actual = numeroDocumento3.value.padStart(9, "0");
      };
  },
  data: function() {
    return {
      modelValue: this.value,
      url: url,
      tiposComprobante: [],
      selectedTipoComprobante: null,
      errores: {
        numero_secuencia: undefined,
        descripcion: undefined,
        tipo: undefined,
        numero_inicial: undefined,
        numero_actual: undefined,
        numero_final: undefined,
        numero_autorizacion: undefined,
        fecha_autorizacion: undefined,
        id_tipo_comprobante: undefined,
        fecha_caducidad: undefined,
        medida_superior: undefined,
        medida_inferior: undefined
      },
      selectedUsuarios: [],
      usuarios: [],
      cargaInicial: false,
      usuariosEditados: []
    };
  },
  methods: {
    formularioValido: function() {
      this.errores = {};
      let tieneErrores = false;
      if (this.modelValue.numero_secuencia === "") {
        this.errores.numero_secuencia = [
          "El número de secuencia es requerido."
        ];
        tieneErrores = true;
      }
      if (this.modelValue.descripcion === "") {
        this.errores.descripcion = ["La descripción es requerida."];
        tieneErrores = true;
      }
      if (this.modelValue.tipo === "") {
        this.errores.tipo = ["El tipo es requerido."];
        tieneErrores = true;
      } else if (this.modelValue.tipo === "M") {
        if (this.modelValue.numero_final === "") {
          this.errores.numero_final = ["El número final es requerido."];
          tieneErrores = true;
        }
        if (this.modelValue.numero_inicial === "") {
          this.errores.numero_inicial = ["El número inicial es requerido."];
          tieneErrores = true;
        }
        if (this.modelValue.numero_actual === "") {
          this.errores.numero_actual = ["El número actual es requerido."];
          tieneErrores = true;
        }
        if (
          this.modelValue.numero_autorizacion === "" &&
          this.modelValue.id_tipo_comprobante !== "00"
        ) {
          this.errores.numero_autorizacion = [
            "El número de autorización es requerido."
          ];
          tieneErrores = true;
        }
        if (
          this.modelValue.fecha_autorizacion === "" &&
          this.modelValue.id_tipo_comprobante !== "00"
        ) {
          this.errores.fecha_autorizacion = [
            "La fecha de autorización es requerida."
          ];
          tieneErrores = true;
        }
        if (
          this.modelValue.numero_final !== "" &&
          this.modelValue.numero_inicial !== "" &&
          this.modelValue.numero_actual !== ""
        ) {
          let numeroFinal = parseInt(this.modelValue.numero_final);
          let numeroInicial = parseInt(this.modelValue.numero_inicial);
          let numeroActual = parseInt(this.modelValue.numero_actual);
          if (numeroInicial > numeroActual) {
            this.errores.numero_inicial = [
              "El número inicial no puede ser mayor al número actual."
            ];
            tieneErrores = true;
          }
          if (numeroFinal < numeroActual) {
            this.errores.numero_final = [
              "El número final no puede ser menor al número actual."
            ];
            tieneErrores = true;
          }
        }
        if (
          this.modelValue.fecha_caducidad === null ||
          (this.modelValue.fecha_caducidad === undefined &&
            this.modelValue.id_tipo_comprobante !== "00")
        ) {
          this.errores.fecha_caducidad = [
            "La fecha de caducidad es requerida."
          ];
          tieneErrores = true;
        }
        if (this.modelValue.pre_impresion) {
          if (
            this.modelValue.medida_superior === undefined ||
            this.modelValue.medida_superior === null ||
            this.modelValue.medida_superior === ""
          ) {
            this.errores.medida_superior = ["La medida superior es requerida."];
            tieneErrores = true;
          }
          if (
            this.modelValue.medida_inferior === undefined ||
            this.modelValue.medida_inferior === null ||
            this.modelValue.medida_inferior === ""
          ) {
            this.errores.medida_inferior = ["La medida inferior es requerida."];
            tieneErrores = true;
          }
        }
      }
      if (this.modelValue.id_tipo_comprobante === "") {
        this.errores.id_tipo_comprobante = [
          "El tipo de comprobante es requerido."
        ];
        tieneErrores = true;
      }
      return tieneErrores;
    },
    aceptar: function() {
      if (!this.formularioValido()) this.$emit("input", this.modelValue);
      else swal("El formulario tiene errores.", "Error", "warning");
    },
    cerrar: function() {
      this.$emit("cerrar");
    },
    cargarDatos: function() {
      let that = this;
      axios.get(this.url + "/puntos-emision/datos").then(function(response) {
        that.tiposComprobante = response.data.tiposComprobante;
        for (let i = 0; i < that.tiposComprobante.length; i++)
          if (
            that.tiposComprobante[i].id_tipo_comprobante ===
            that.value.id_tipo_comprobante
          ) {
            that.selectedTipoComprobante = that.tiposComprobante[i];
            break;
          }
      });
    },
    cargarUsuarios: function() {
      let that = this;
      axios
        .get(
          this.url +
            "/usuarios/" +
            this.selectedTipoComprobante.id_tipo_comprobante +
            "/lista"
        )
        .then(function(response) {
          that.usuarios = response.data;
          if (that.cargaInicial) {
            for (let j = 0; j < that.usuarios.length; j++)
              for (let i = 0; i < that.usuariosEditados.length; i++)
                if (that.usuariosEditados[i] == that.usuarios[j].id)
                  that.selectedUsuarios.push(that.usuarios[j]);
            that.usuariosEditados = [];
            that.cargaInicial = false;
          }
        });
    }
  },
  watch: {
    selectedTipoComprobante: function(value) {
      if (value !== undefined && value !== null) {
        this.modelValue.id_tipo_comprobante = value.id_tipo_comprobante;
        if (
          this.modelValue.id_tipo_comprobante === "00" ||
          this.modelValue.id_tipo_comprobante === "99"
        ) {
          this.modelValue.tipo = "M";
          if (this.modelValue.id_tipo_comprobante === "00") {
            this.modelValue.numero_inicial = "000000001";
            this.modelValue.numero_final = "999999999";
          }
        }
        this.selectedUsuarios = [];
        this.cargarUsuarios();
      } else {
        this.selectedUsuarios = [];
        this.modelValue.id_tipo_comprobante = "";
        this.usuarios = [];
      }
    },
    selectedUsuarios: function(value) {
      if (value.length === 0) this.modelValue.usuarios = [];
      else
        for (let i = 0; i < this.usuarios.length; i++)
          this.modelValue.usuarios.push(this.usuarios[i].id);
    }
  },
  mounted: function() {
    this.cargaInicial = true;
    this.usuariosEditados = JSON.parse(JSON.stringify(this.value.usuarios));
    this.cargarDatos();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/localidades/PuntoEmision.vue